class NewsletterPopup extends ModalDialog {
  constructor() {
    super();
    this.init();
    this.attachEventListeners();
  }

  attachEventListeners() {
    this.buttonClose = this.querySelector(".js-button-close");
    if (this.buttonClose) {
      this.buttonClose.addEventListener("click", this.closeNewsletter.bind(this));
    }

    if (this.form) {
      this.form.addEventListener("submit", this.onSubscribe.bind(this));
    }
  }

  init() {
    this.delay = this.dataset.delay * 1000 || 0;
    this.closed = getCookie("newsletter-closed");
    this.subscribed = getCookie("newsletter-subscribed");
    this.form = this.querySelector(".js-form");
    this.ageVerificationPopup = document.querySelector("age-verification-popup");

    // NEW: detect geolocation popup
    this.geoPopup = document.getElementById("glc-geo");
  }

  closeNewsletter() {
    setCookie("newsletter-closed", "true");
    this.hide();
  }

  connectedCallback() {
    if (Shopify.designMode) {
      if (this.dataset.openInDesignMode === "true") this.show();
      return;
    }

  const waitForGeo = () => {
    const geoClosed = localStorage.getItem("geo-popup-closed");

    if (geoClosed === "true") {
      this.startNewsletterTimer();
    } else {
      setTimeout(waitForGeo, 300);
    }
  };

  waitForGeo();
}

  // NEW: helper to check geo visibility
  isGeoVisible() {
    if (!this.geoPopup) return false;
    const style = getComputedStyle(this.geoPopup);
    if (style.display === "none" || this.geoPopup.classList.contains("hidden")) return false;
    const modal = this.geoPopup.querySelector(".glc-geo-modal");
    return modal ? getComputedStyle(modal).display !== "none" : true;
  }

  // NEW: observe when geo closes, then show newsletter
  waitForGeoThenShow() {
    const observer = new MutationObserver(() => {
      if (!this.isGeoVisible()) {
        observer.disconnect();
        this.handlePopupVisibility();
      }
    });
    observer.observe(this.geoPopup, { attributes: true, attributeFilter: ["style", "class"] });

    // fallback: if geo is removed from DOM
    const interval = setInterval(() => {
      if (!document.body.contains(this.geoPopup) || !this.isGeoVisible()) {
        clearInterval(interval);
        observer.disconnect();
        this.handlePopupVisibility();
      }
    }, 500);
  }

  handlePopupVisibility() {
    if (getCookie("age-verified") !== "true" && this.ageVerificationPopup) {
      this.handleAgeVerificationPopup();
    } else {
      this.showPopupWithDelay();
    }
  }

  handleAgeVerificationPopup() {
    let prevClassState = this.classList.contains("newsletter-popup-is-hidden");

    const observer = new MutationObserver((mutations) => {
      const mutation = mutations[0];
      if (mutation.attributeName !== "class") return;

      const currentClassState = mutation.target.classList.contains("newsletter-popup-is-hidden");

      if (prevClassState !== currentClassState) {
        prevClassState = currentClassState;
        if (!currentClassState) {
          this.showPopupWithDelay();
        }
      }
    });

    observer.observe(this, { attributes: true });
  }

  // ✅ ADD THIS METHOD HERE
  startNewsletterTimer() {
    setTimeout(() => {
      if (this.closed !== "true" && this.subscribed !== "true") {
        this.show();
      }
    }, this.delay);
  }

  showPopupWithDelay() {
    if (this.closed !== "true" && this.subscribed !== "true") {
      this.show();
    }
  }

  onSubscribe() {
    setCookie("newsletter-subscribed", "true");
    this.hide();
  }
}

customElements.define("newsletter-popup", NewsletterPopup);
